import './store-badges.css';

interface StoreBadgesProps {
  appStoreUrl: string;
  playStoreUrl: string;
  appName: string;
}

export function StoreBadges({ appStoreUrl, playStoreUrl, appName }: StoreBadgesProps) {
  return (
    <div className="store-badges">
      <a
        href={appStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="store-badges__link"
        aria-label={`Descargar ${appName} en el App Store`}
      >
        <img
          src="/images/store-badges/app-store-es.svg"
          alt="Disponible en App Store"
          height={40}
        />
      </a>
      <a
        href={playStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="store-badges__link"
        aria-label={`Descargar ${appName} en Google Play`}
      >
        <img
          src="/images/store-badges/google-play-es.png"
          alt="Disponible en Google Play"
          height={40}
        />
      </a>
    </div>
  );
}
